module.exports = __webpack_public_path__ + "img/circleArrow_02.0350ae28.png";